export function sortLanguageOptionsForDisplay(options, currentLanguage, locale = 'ru') {
    const normalizedCurrent = currentLanguage?.split('-')[0] ?? '';
    const collator = new Intl.Collator(locale, {
        sensitivity: 'base',
        numeric: true,
    });
    return [...options].sort((left, right) => {
        const leftIsCurrent = left.value === normalizedCurrent;
        const rightIsCurrent = right.value === normalizedCurrent;
        if (leftIsCurrent && !rightIsCurrent)
            return -1;
        if (!leftIsCurrent && rightIsCurrent)
            return 1;
        return collator.compare(left.label, right.label);
    });
}
//# sourceMappingURL=languageDisplay.js.map